(() => {
  'use strict';

  function isHome() {
    return document.body?.classList.contains('index-template');
  }

  function simplifyCollectionShop() {
    if (!isHome()) return;

    const section = document.getElementById('KSCollectionShop');
    if (!section) return;

    const header = section.querySelector('.ks-weaves__header');
    header?.querySelector('.ks-section-eyebrow')?.remove();
    header?.querySelector('p')?.remove();

    section.querySelectorAll('.ks-weave-card:not(.ks-weave-card--soon)').forEach((card) => {
      const content = card.querySelector('.ks-weave-card__content');
      const title = content?.querySelector('strong');
      if (!content || !title) return;

      const cleanTitle = title.cloneNode(true);
      content.replaceChildren(cleanTitle);
    });
  }

  function placeBestSellers() {
    if (!isHome()) return;

    const bestSellers = document.getElementById('KSBestSellers');
    if (!bestSellers) return;

    const newArrivals = document.getElementById('KSNewArrivals');
    const founder = document.querySelector('[id*="image_with_text_MgddA8"]');

    if (newArrivals?.parentNode) {
      newArrivals.parentNode.insertBefore(bestSellers, newArrivals);
    } else if (founder?.parentNode) {
      founder.parentNode.insertBefore(bestSellers, founder);
    }

    bestSellers.hidden = false;
  }

  function init() {
    simplifyCollectionShop();
    placeBestSellers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(init, 0);
  });
})();

/* KS HERO ARTWORK — ACCOUNT CONTINUE SHOPPING FIX */
(() => {
  'use strict';

  const desktopHero = 'https://cdn.shopify.com/s/files/1/0831/8051/9683/files/ks-hero-maroon-natural-desktop.png?v=1787203091';
  const mobileHero = 'https://cdn.shopify.com/s/files/1/0831/8051/9683/files/ks-hero-maroon-natural-mobile.png?v=1787203109';

  function applyKSHeroArtwork() {
    if (!document.body?.classList.contains('index-template')) return;

    const firstSlide = document.querySelector(
      '.section-slideshow_q3U4Jn .swiper-slide[data-index="0"]'
    );
    if (!firstSlide) return;

    const picture = firstSlide.querySelector('.slideshow__slide-bg picture');
    if (!picture) return;

    const mobileSource = picture.querySelector(
      'source[media*="max-width: 767px"]'
    );
    const desktopImage = picture.querySelector('img');

    if (mobileSource) {
      mobileSource.setAttribute('srcset', mobileHero);
    }

    if (desktopImage) {
      desktopImage.setAttribute('src', desktopHero);
      desktopImage.setAttribute('srcset', desktopHero);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyKSHeroArtwork, { once: true });
  } else {
    applyKSHeroArtwork();
  }

  document.addEventListener('shopify:section:load', applyKSHeroArtwork);
  window.setTimeout(applyKSHeroArtwork, 500);
  window.setTimeout(applyKSHeroArtwork, 1500);
})();

/* KS CATEGORY LINK MAP — NO 404 */
(() => {
  'use strict';

  const editLinks = [
    '/collections/all?sort_by=best-selling',
    '/collections/all?sort_by=created-descending',
    '/collections/kanjivaram-saree',
    '/collections/premium-soft-silk-saree'
  ];

  const priceLinks = [
    '/collections/under-2-000',
    '/collections/all?filter.v.price.gte=2000&filter.v.price.lte=5000',
    '/collections/all?filter.v.price.gte=5000&filter.v.price.lte=10000',
    '/collections/all?filter.v.price.gte=10000&filter.v.price.lte=15000',
    '/collections/all?filter.v.price.gte=15000'
  ];

  function applyCategoryLinks() {
    if (!document.body?.classList.contains('index-template')) return;

    document.querySelectorAll('.ks-edit__card').forEach((card, i) => {
      if (editLinks[i]) card.setAttribute('href', editLinks[i]);
    });

    document.querySelectorAll('.ks-price-item').forEach((item, i) => {
      if (priceLinks[i]) item.setAttribute('href', priceLinks[i]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCategoryLinks, { once: true });
  } else {
    applyCategoryLinks();
  }

  document.addEventListener('shopify:section:load', applyCategoryLinks);
  window.setTimeout(applyCategoryLinks, 250);
  window.setTimeout(applyCategoryLinks, 1000);
})();

/* KS MOBILE MERCH POLISH — 2x2 price shop + compact customer feedback */
(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const originalPriceMarkup = new WeakMap();

  const desktopPriceLinks = [
    '/collections/under-2-000',
    '/collections/all?filter.v.price.gte=2000&filter.v.price.lte=5000',
    '/collections/all?filter.v.price.gte=5000&filter.v.price.lte=10000',
    '/collections/all?filter.v.price.gte=10000&filter.v.price.lte=15000',
    '/collections/all?filter.v.price.gte=15000'
  ];

  const mobilePriceBands = [
    {
      href: '/collections/all?filter.v.price.lte=1000',
      aria: 'Shop sarees under 1,000 rupees',
      circle: '<span class="ks-price-kicker">UNDER</span><strong>₹1,000</strong>',
      caption: 'Under ₹1,000'
    },
    {
      href: '/collections/all?filter.v.price.gte=1000&filter.v.price.lte=2000',
      aria: 'Shop sarees from 1,000 to 2,000 rupees',
      circle: '<strong>₹1,000</strong><span class="ks-price-to">TO</span><strong>₹2,000</strong>',
      caption: '₹1,000–₹2,000'
    },
    {
      href: '/collections/all?filter.v.price.gte=2000&filter.v.price.lte=3000',
      aria: 'Shop sarees from 2,000 to 3,000 rupees',
      circle: '<strong>₹2,000</strong><span class="ks-price-to">TO</span><strong>₹3,000</strong>',
      caption: '₹2,000–₹3,000'
    },
    {
      href: '/collections/all?filter.v.price.gte=3000',
      aria: 'Shop sarees priced 3,000 rupees and above',
      circle: '<span class="ks-price-kicker">ABOVE</span><strong>₹3,000</strong>',
      caption: '₹3,000+'
    }
  ];

  function isHome() {
    return document.body?.classList.contains('index-template');
  }

  function ensureMobilePolishStyles() {
    if (document.getElementById('KSMobileMerchPolish')) return;

    const style = document.createElement('style');
    style.id = 'KSMobileMerchPolish';
    style.textContent = `
      @media screen and (max-width: 749px) {
        body.index-template #MainContent .ks-price-shop > .page-width {
          width: 100% !important;
          max-width: none !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        body.index-template #MainContent .ks-price-title {
          margin-bottom: 20px !important;
          padding-left: 18px !important;
          padding-right: 18px !important;
        }

        body.index-template #MainContent .ks-price-grid {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 18px 12px !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 18px 4px !important;
          overflow: visible !important;
          scroll-snap-type: none !important;
          scroll-padding: 0 !important;
        }

        body.index-template #MainContent .ks-price-item {
          display: block !important;
          width: auto !important;
          min-width: 0 !important;
          margin: 0 !important;
          flex: none !important;
          scroll-snap-align: none !important;
        }

        body.index-template #MainContent .ks-price-circle {
          width: min(100%, 140px) !important;
          max-width: 140px !important;
          margin-bottom: 8px !important;
        }

        body.index-template #MainContent .ks-price-circle strong {
          font-size: 20px !important;
        }

        body.index-template #MainContent .ks-price-caption {
          font-size: 13px !important;
          line-height: 1.3 !important;
        }

        body.index-template #MainContent [id*="custom_liquid_eQJdU4"] .ks-feedback-section,
        body.index-template #MainContent .ks-feedback-section {
          padding: 28px 14px 30px !important;
        }

        body.index-template #MainContent .ks-feedback-heading {
          font-size: 31px !important;
          line-height: 1.08 !important;
        }

        body.index-template #MainContent .ks-feedback-note {
          margin: 7px 0 18px !important;
        }

        body.index-template #MainContent .ks-feedback-page {
          grid-template-columns: none !important;
          grid-auto-columns: 78% !important;
          grid-auto-flow: column !important;
          gap: 12px !important;
          padding: 2px 3px 6px !important;
          overflow-x: auto !important;
          scroll-snap-type: x mandatory !important;
          scroll-padding-inline: 3px !important;
        }

        body.index-template #MainContent .ks-review-card {
          min-height: 0 !important;
          padding: 22px 18px 20px !important;
          border: 1px solid rgba(197, 145, 44, .18) !important;
          border-radius: 14px !important;
          box-shadow: 0 8px 22px rgba(62, 26, 19, .07) !important;
          scroll-snap-align: start !important;
        }

        body.index-template #MainContent .ks-review-stars {
          margin-bottom: 11px !important;
          font-size: 17px !important;
          letter-spacing: .5px !important;
        }

        body.index-template #MainContent .ks-review-text {
          font-size: 14.5px !important;
          line-height: 1.55 !important;
        }

        body.index-template #MainContent .ks-review-name {
          margin-top: 15px !important;
          font-size: 18px !important;
          line-height: 1.25 !important;
        }

        body.index-template #MainContent .ks-review-location {
          margin-top: 2px !important;
          font-size: 12px !important;
        }

        body.index-template #MainContent .ks-feedback-pagination {
          gap: 9px !important;
          margin-top: 18px !important;
        }

        body.index-template #MainContent .ks-feedback-dot {
          width: 8px !important;
          height: 8px !important;
        }

        body.index-template #MainContent .ks-feedback-dot.is-active {
          width: 16px !important;
          height: 16px !important;
        }
      }

      @media screen and (max-width: 390px) {
        body.index-template #MainContent .ks-feedback-page {
          grid-auto-columns: 82% !important;
        }

        body.index-template #MainContent .ks-review-card {
          padding: 20px 16px 18px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function rememberDesktopMarkup(item, index) {
    if (originalPriceMarkup.has(item)) return;

    const circle = item.querySelector('.ks-price-circle');
    const caption = item.querySelector('.ks-price-caption');

    originalPriceMarkup.set(item, {
      href: desktopPriceLinks[index] || item.getAttribute('href') || '',
      aria: item.getAttribute('aria-label') || '',
      circle: circle?.innerHTML || '',
      caption: caption?.textContent || ''
    });
  }

  function applyPriceBand(item, band) {
    const circle = item.querySelector('.ks-price-circle');
    const caption = item.querySelector('.ks-price-caption');

    item.hidden = false;
    item.setAttribute('href', band.href);
    item.setAttribute('aria-label', band.aria);
    if (circle) circle.innerHTML = band.circle;
    if (caption) caption.textContent = band.caption;
  }

  function restoreDesktopBand(item) {
    const saved = originalPriceMarkup.get(item);
    if (!saved) return;

    const circle = item.querySelector('.ks-price-circle');
    const caption = item.querySelector('.ks-price-caption');

    item.hidden = false;
    item.setAttribute('href', saved.href);
    item.setAttribute('aria-label', saved.aria);
    if (circle) circle.innerHTML = saved.circle;
    if (caption) caption.textContent = saved.caption;
  }

  function syncMobilePriceShop() {
    if (!isHome()) return;

    const items = Array.from(document.querySelectorAll('.ks-price-shop .ks-price-item'));
    if (!items.length) return;

    items.forEach(rememberDesktopMarkup);

    if (mobileQuery.matches) {
      items.forEach((item, index) => {
        if (index < mobilePriceBands.length) {
          applyPriceBand(item, mobilePriceBands[index]);
        } else {
          item.hidden = true;
        }
      });
      return;
    }

    items.forEach(restoreDesktopBand);
  }

  function initMobileMerchPolish() {
    if (!isHome()) return;
    ensureMobilePolishStyles();
    syncMobilePriceShop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMerchPolish, { once: true });
  } else {
    initMobileMerchPolish();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncMobilePriceShop);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncMobilePriceShop);
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(initMobileMerchPolish, 0);
    window.setTimeout(syncMobilePriceShop, 1200);
  });

  window.setTimeout(syncMobilePriceShop, 1200);
  window.setTimeout(syncMobilePriceShop, 1800);
})();
